<template> 
    <div :style="{visibility: modalsPresent ?'visible': 'hidden'}" class="modal-pane"> 
        <div class="modal-mask" @click.self="onEscape"> 
            <div class="modal-wrapper" @click.self="onEscape">
                <div class="modal-container" @click.self="onEscape">
                    <div class="container" style="max-width: 600px;">
                        <div ref="modalMountTarget" />
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
import { MODAL_BUS } from "./modal-plugin";

import Vue from "vue";

export default {
  name: "modal-pane",
  props: ["pane-name"],
  data() {
    return {
      currentModal: null
    };
  },
  computed: {
    modalsPresent() {
      return this.currentModal ? true : false;
    }
  },
  methods: {
    onEscape() {
      const that = this;
      if (that.modalsPresent) {
        let modal = that.currentModal;
        if (modal.allowEscape) {
          // remove modal
          that.destroyCurrentModal();
          // resolve the promise
          modal.resolve({ wasEscaped: true, returnValue: null });
        }
      }
    },
    destroyCurrentModal() {
      const that = this;
      let modalMountTarget = that.$refs.modalMountTarget;
      if (that.currentModal) {
        that.currentModal._modalComponentInstance.$destroy();
        that.currentModal._modalComponentInstance.$el = null;
        modalMountTarget.innerHTML = "";
        that.currentModal = null;
      }
    },
    showModal(args) {
      const that = this;
      if (args.paneName === (that.paneName || "app")) {
        try {
          if (that.modalsPresent) {
            throw new Error("can not show more than one modal!");
          }
          let modalMountTarget = that.$refs.modalMountTarget;
          let ModalComponent = args.modalComponent;
          let component = new ModalComponent();
          if (args.modalArgs) {
            Object.keys(args.modalArgs).forEach(k =>
              Vue.set(component, k, args.modalArgs[k])
            );
          }
          component.$once("close", returnValue => {
            that.destroyCurrentModal();
            args.resolve({
              wasEscaped: false,
              returnValue: returnValue
            });
          });
          args._modalComponentInstance = component;
          that.currentModal = args;
          component.$mount();
          modalMountTarget.appendChild(component.$el);
        } catch (error) {
          args.reject(new Error("error creating the modal: " + error.message));
        }
      }
    }
  },
  mounted() {
    MODAL_BUS.$on("show-modal", this.showModal);
  }
};
</script>
 

<style scoped>
.modal-pane {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
}
.modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  width: 100%;
  height: 100%;

  overflow: auto;
  z-index: 200;

  background-color: rgba(0, 0, 0, 0.3);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  margin: auto;
}

.modal-container {
  margin: 0px auto;
  padding: 20px 30px;
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
